class Header {
  constructor() {
    if (!document.querySelector('.js-header')) return;

    document.addEventListener('alpine:init', () => {
      Alpine.data('headerNav', () => ({
        menuOpen: false,

        toggleMenu() {
          this.menuOpen = !this.menuOpen;
          this.syncScrollLock();
        },

        closeMenu() {
          if (!this.menuOpen) return;
          this.menuOpen = false;
          this.syncScrollLock();
        },

        syncScrollLock() {
          if (this.menuOpen) {
            scrollBanOpen();
          } else {
            scrollBanClose();
          }
        },
      }));
    });
  }
}
